import styled from 'styled-components';

export const Container = styled.div`
    flex: 1;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const UploadItems = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    padding: 20px;
`;

export const UploadFile = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    width: 100%;
    padding-bottom: 10px;
`;

export const UploadFileName = styled.input`
    flex: 1;
    border: 1px solid #444;
    padding: 0 5px;
    margin: 0 30px 0 0;
    background-color: transparent;
    height: 30px;
    color: #fff;
`;

export const UploadFileSize = styled.div`
    width: 70px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    color: #999;
`;

export const UploadFileNameLabel = styled.div`
    flex: 1;
    padding: 0 5px;
    margin: 0;
    height: 30px;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

export const FilesList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    flex: 1;
`;

export const FileItem = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    color: #fff;

    &.selected {
        background-color: #333;
    }
`;

export const FileItemLabel = styled.div`
    flex: ${props => props.size};
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    height: 30px;
    padding-left: 20px;
    border-bottom: 1px solid #555;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

export const FileItemValue = styled.div`
    flex: ${props => props.size};
    color: #ccc;
    font-size: 12px;
    height: 30px;
    display: flex;
    padding-left: 20px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    ${FileItem}:not(.selected):hover & {
        background-color: #444;
    }
`;

export const UploadFileStatus = styled.div`
    width: 100%;
    padding: 0 5px;
    margin: 0;
    height: 30px;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;

    &.waiting {color: #777;}
    &.ok {color: #0c0;}
    &.error {color: #f44;}
`;

export const UploadProgress = styled.div.attrs(props => ({
    style: {
        width: props.progress + '%'
    }
}))`
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 0;

    .waiting & {background-color: #555;}
    .ok & {background-color: #050;}
    .error & {background-color: #500;}
`;

export const UploadProgressText = styled.div`
    position: relative;
    z-index: 1;
`;

export const FilemanagerSummary = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    border-top: 1px solid #444;
`;

export const FilemanagerBlock = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 10px;

    &:first-child {
        border-right: 1px solid #444;
    }
`;

export const FilemanagerBlockTitle = styled.div`
    width: 100%;
    font-size: 12px;
    text-transform: uppercase;
    color: #777;
`;

export const FilemanagerBlockValue = styled.div`
    width: 100%;
    font-size: 14px;
    color: #ccc;
`;

export const FilemanagerButton = styled.div`
    border: 1px solid ${props => props.color};
    color: ${props => props.color};
    padding: 0 15px;
    height: 30px;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: color .3s ease 0s, background-color .3s ease 0s;

    :hover {
        color: ${props => props.hoverColor || '#fff' };
        background-color: ${props => props.color};
    }
`;